import {AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {merge, of as observableOf, timer} from 'rxjs';
import {catchError, debounce, map, startWith, switchMap} from 'rxjs/operators';
import {MatTable} from '@angular/material/table';
import {FormArray, FormControl} from '@angular/forms';
import {MatSnackBar} from '@angular/material/snack-bar';
import {ActivatedRoute, Router} from '@angular/router';
import {JournalEntryService} from './journal-entry.service';
import {JournalEntry} from './journal-entry.models';
import {SearchFilters} from "../location/location.models";
import {FiltersService, LocationService} from "../location/location.service";

@Component({
    selector: 'journal-entry',
    templateUrl: './journal-entry.component.html',
    styleUrls: ['./journal-entry.component.css']
})
export class JournalEntryComponent implements AfterViewInit {
    readonly LOCAL_STORAGE_FILTERS_SUFFIX = 'journal-entries-02';
    displayedColumns: string[] = ['location', 'transactionDate', 'externalId', 'originalId', 'createdAt', 'status'];
    data: JournalEntry[] = [];
    isLoadingResults = true;
    resultsLength = 0;
    pageSize = 25;
    controls: FormArray;
    filters: SearchFilters;
    fromDate = new FormControl();
    toDate = new FormControl();
    includeDeleted = false;

    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild(MatTable) table: MatTable<any>;

    constructor(public route: ActivatedRoute,
                public router: Router,
                public journalEntryService: JournalEntryService,
                public locationService: LocationService,
                private _snackBar: MatSnackBar,
                private filtersService: FiltersService) {
        this.initFilters();
    }

    loadLocations() {
        this.locationService.findAll().subscribe(
            response => {
                this.filters.location.options = response;
            },
            error => {
                console.log(error);
            });
    }

    private initFilters() {
        this.filters = this.filtersService.getFilters(this.LOCAL_STORAGE_FILTERS_SUFFIX);
        this.loadLocations();
    }

    ngAfterViewInit() {
        this.sort.sortChange.subscribe(() => (this.paginator.pageIndex = 0));
        merge(this.sort.sortChange, this.paginator.page)
            .pipe(
                startWith({}),
                debounce(() => timer(500)),
                switchMap(() => {
                    this.isLoadingResults = true;
                    return this.journalEntryService.find(this.sort.active, this.sort.direction, this.paginator.pageIndex,
                        this.paginator.pageSize, this.filtersService.buildSearchParam(this.filters), this.fromDate.value,
                        this.toDate.value, this.includeDeleted)
                        .pipe(catchError(() => observableOf(null)));
                }),
                map(result => {
                    this.isLoadingResults = false;
                    // @ts-ignore
                    this.resultsLength = result?.totalElements;
                    const data = result?.content;
                    return data;
                }),
            )
            .subscribe(data => {
                this.data = data;
            });
    }

    reset() {
        this.paginator.pageIndex = 0;
        this.paginator._changePageSize(this.paginator.pageSize);
    }

    updateFilter() {
        this.filtersService.saveFilters(this.filters, this.LOCAL_STORAGE_FILTERS_SUFFIX);
        this.reset();
    }

    resetGrid() {
        this.filtersService.resetFilters(this.LOCAL_STORAGE_FILTERS_SUFFIX);
        this.initFilters();
        this.reset();
    }

    calculateActiveFiltersCount() {
        let result = 0;
        for (const [key, value] of Object.entries(this.filters)) {
            if (value.value) {
                result++;
            }
        }
        return result;
    }
}
